import { UserAccess } from './../../shared/models/user-access.model';
import { User } from './../../shared/models/user.model';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthBaseService {
  private loggedUserSubject: BehaviorSubject<{ user: User, userAccess: UserAccess[] }> = new BehaviorSubject({ user: new User(), userAccess: [] });

  private loggedAuthTokenSubject: BehaviorSubject<User> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
  }
  setCallbackUrl(url: string): void {
    sessionStorage.setItem('callback-url', url);
  }
  getCallbackUrl(): string {
    return sessionStorage.getItem('callback-url');
  }
  clearCallbackUrl(): void {
    sessionStorage.removeItem('callback-url');
  }

  login(model: { login: string, senha: string }): Observable<User> {
    const url = `${environment.api_url}public/login`;

    return this.http.post<User>(url, model);
  }

  meusDados(): Observable<User> {
    const url = `${environment.api_url}public/login`;
    return this.http.get<User>(url);
  }

  logout(): void {
    this.router.navigate(['/login']);
    this.removeLocalStorageToken();
    // this.loggedAuthTokenSubject.next(null);
    // window.location.reload();
    // .then(() => {
    // });
  }

  setLoggedUser(authToken: User): void {
    this.setLocalStorageToken(authToken.id);
    this.loggedAuthTokenSubject.next(authToken);
  }

  getAuthToken(): Observable<User> {
    return this.loggedAuthTokenSubject;
  }

  getLoggedUser(): Observable<{ user: User, userAccess: UserAccess[] }> {
    return this.loggedUserSubject;
  }

  setLocalStorageToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getLocalStorageToken(): string {
    return localStorage.getItem('token');
  }

  removeLocalStorageToken(): void {
    localStorage.removeItem('token');
  }
}
